/** Node types that produce output only (no incoming handle) */
export const SOURCE_ONLY_TYPES = new Set([
  "InputNode",
  "InputNodeV2",
  "flow_input",
  "FixedValueNode",
  "CaseStartedV2",
  "EmailFilterInputV2",
  "EmailExtractionInputV2",
  "TaskAutomationInputV2",
]);

/** Node types that consume input only (no outgoing handle) */
export const SINK_ONLY_TYPES = new Set([
  "OutputNode",
  "OutputNodeV2",
  "flow_output",
  "CaseCompletedV2",
  "EmailFilterOutputV2",
  "EmailExtractionOutputV2",
  "TaskAutomationOutputV2",
]);

/** Flow input nodes whose configured value the runner collects as a workflow input. */
export const FLOW_INPUT_NODE_TYPES = new Set(["InputNode", "InputNodeV2"]);

export function isFlowInputNode(nodeType: string | undefined | null): boolean {
  return !!nodeType && FLOW_INPUT_NODE_TYPES.has(nodeType);
}

/** Flow output nodes that expose a workflow result. */
export const FLOW_OUTPUT_NODE_TYPES = new Set(["OutputNode", "OutputNodeV2"]);

export function isFlowOutputNode(nodeType: string | undefined | null): boolean {
  return !!nodeType && FLOW_OUTPUT_NODE_TYPES.has(nodeType);
}
